export default {
  // 页面标题和导航
  'pages.water-fee.title': '水费',
  'pages.water-fee.subtitle': '管理小区水费账单的生成、缴费和查询',
  'pages.water-fee.currentSelection': '当前选择：',
  'pages.water-fee.batchImport': '批量导入',
  'pages.water-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.water-fee.tabOther': '其他',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.waterFee': '水费',

  // 表格相关
  'pages.water-fee.table.title': '水费账单列表',
  'pages.water-fee.table.houseInfo': '房屋信息',
  'pages.water-fee.table.period': '账期',
  'pages.water-fee.table.billNo': '账单编号',
  'pages.water-fee.table.waterUsage': '用水量(吨)',
  'pages.water-fee.table.totalAmount': '总金额',
  'pages.water-fee.table.paymentAmount': '缴费金额',
  'pages.water-fee.table.dueAmount': '应缴',
  'pages.water-fee.table.actualAmount': '实缴',
  'pages.water-fee.table.approvalStatus': '审核状态',
  'pages.water-fee.table.paymentStatus': '缴费状态',
  'pages.water-fee.table.paymentTime': '缴费时间',
  'pages.water-fee.table.dueDate': '到期日期',
  'pages.water-fee.table.action': '操作',

  // 操作按钮
  'pages.water-fee.action.view': '查看',
  'pages.water-fee.action.edit': '编辑',
  'pages.water-fee.action.delete': '删除',
  'pages.water-fee.action.create': '新建账单',
  'pages.water-fee.action.submitAudit': '提交审核',
  'pages.water-fee.action.batchDelete': '批量删除',
  'pages.water-fee.action.confirm': '确定',
  'pages.water-fee.action.cancel': '取消',

  // 删除相关
  'pages.water-fee.delete.confirmTitle': '确定要删除这条记录吗？',
  'pages.water-fee.delete.success': '删除成功',
  'pages.water-fee.delete.failure': '删除失败',
  'pages.water-fee.batchDelete.confirmTitle': '确认删除',
  'pages.water-fee.batchDelete.confirmMessage': '确定要删除选中的 {count} 条记录吗？',
  'pages.water-fee.batchDelete.success': '批量删除成功',
  'pages.water-fee.batchDelete.failure': '批量删除失败',
  'pages.water-fee.delete.batchDelete.noSelection': '请选择要删除的记录',
  'pages.water-fee.delete.batchDelete.draftOnly': '批量删除仅支持草稿状态的账单',

  // 审核相关
  'pages.water-fee.audit.selectBillsWarning': '请选择要提交审核的账单',
  'pages.water-fee.audit.modalTitle': '提交审核',
  'pages.water-fee.audit.submitAudit': '提交审核',
  'pages.water-fee.audit.auditName': '审核名称',
  'pages.water-fee.audit.auditNamePlaceholder': '请输入审核名称',
  'pages.water-fee.audit.auditNameRequired': '请输入审核名称',
  'pages.water-fee.audit.submitRemark': '提交说明',
  'pages.water-fee.audit.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.water-fee.audit.selectedBillsTitle': '选中的账单列表（共 {count} 条）',
  'pages.water-fee.audit.success': '提交审核成功',
  'pages.water-fee.audit.failure': '提交审核失败',
  'pages.water-fee.audit.defaultName': '{period} 水费账单 ({count}笔)',

  // 详情弹窗
  'pages.water-fee.detail.modalTitle': '水费账单详情',
  'pages.water-fee.detail.basicInfo': '基本信息',

  // 详情字段
  'pages.water-fee.detail.billNo': '账单编号',
  'pages.water-fee.detail.period': '账期',
  'pages.water-fee.detail.paymentStatus': '缴费状态',
  'pages.water-fee.detail.approvalStatus': '审核状态',
  'pages.water-fee.detail.startDate': '开始日期',
  'pages.water-fee.detail.endDate': '结束日期',
  'pages.water-fee.detail.houseInfo': '房屋信息',
  'pages.water-fee.detail.ownerInfo': '业主信息',
  'pages.water-fee.detail.ownerIdCard': '身份证',
  'pages.water-fee.detail.ownerEmail': '邮箱',
  'pages.water-fee.detail.ownerId': '业主ID',
  'pages.water-fee.detail.lastReading': '上期读数(吨)',
  'pages.water-fee.detail.lastReadingDate': '上期抄表时间',
  'pages.water-fee.detail.currentReading': '本期读数(吨)',
  'pages.water-fee.detail.currentReadingDate': '本期抄表时间',
  'pages.water-fee.detail.waterUsage': '用水量',
  'pages.water-fee.detail.unitPrice': '单价(元/吨)',
  'pages.water-fee.detail.baseAmount': '基础金额',
  'pages.water-fee.detail.lateFee': '滞纳金',
  'pages.water-fee.detail.discountAmount': '优惠金额',
  'pages.water-fee.detail.finalAmount': '最终金额',
  'pages.water-fee.detail.paymentMethod': '支付方式',
  'pages.water-fee.detail.paymentReference': '支付凭证号',
  'pages.water-fee.detail.dueDate': '到期日期',
  'pages.water-fee.detail.paymentDate': '缴费日期',
  'pages.water-fee.detail.createdTime': '创建时间',
  'pages.water-fee.detail.updatedTime': '更新时间',
  'pages.water-fee.detail.remarks': '备注',

  // 表单相关
  'pages.water-fee.form.editTitle': '编辑水费账单',
  'pages.water-fee.form.createTitle': '新建水费账单',
  'pages.water-fee.form.basicInfo': '基本信息',
  'pages.water-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.water-fee.form.meterReadingInfo': '水表读数信息',
  'pages.water-fee.form.feeInfo': '费用信息',
  'pages.water-fee.form.remarksInfo': '备注信息',
  'pages.water-fee.form.update': '更新',
  'pages.water-fee.form.create': '创建',
  'pages.water-fee.form.cancel': '取消',

  // 表单字段
  'pages.water-fee.form.billNo': '账单编号',
  'pages.water-fee.form.billNoPlaceholder': '请输入账单编号',
  'pages.water-fee.form.paymentStatus': '缴费状态',
  'pages.water-fee.form.paymentStatusPlaceholder': '请选择缴费状态',
  'pages.water-fee.form.period': '账期',
  'pages.water-fee.form.periodPlaceholder': '如：2024-01',
  'pages.water-fee.form.periodRequired': '请输入账期',
  'pages.water-fee.form.startDate': '开始日期',
  'pages.water-fee.form.startDatePlaceholder': '请选择开始日期',
  'pages.water-fee.form.startDateRequired': '请选择开始日期',
  'pages.water-fee.form.endDate': '结束日期',
  'pages.water-fee.form.endDatePlaceholder': '请选择结束日期',
  'pages.water-fee.form.endDateRequired': '请选择结束日期',
  'pages.water-fee.form.building': '楼栋',
  'pages.water-fee.form.buildingPlaceholder': '请选择楼栋',
  'pages.water-fee.form.buildingRequired': '请选择楼栋',
  'pages.water-fee.form.floor': '楼层',
  'pages.water-fee.form.floorPlaceholder': '请选择楼层',
  'pages.water-fee.form.floorRequired': '请选择楼层',
  'pages.water-fee.form.house': '房屋',
  'pages.water-fee.form.housePlaceholder': '请选择房屋',
  'pages.water-fee.form.houseRequired': '请选择房屋',
  'pages.water-fee.form.lastReading': '上期读数',
  'pages.water-fee.form.lastReadingPlaceholder': '请输入上期读数',
  'pages.water-fee.form.lastReadingDate': '上期抄表时间',
  'pages.water-fee.form.lastReadingDatePlaceholder': '请选择上期抄表时间',
  'pages.water-fee.form.currentReading': '本期读数',
  'pages.water-fee.form.currentReadingPlaceholder': '请输入本期读数',
  'pages.water-fee.form.currentReadingRequired': '请输入本期读数',
  'pages.water-fee.form.currentReadingDate': '本期抄表时间',
  'pages.water-fee.form.currentReadingDatePlaceholder': '请选择本期抄表时间',
  'pages.water-fee.form.currentReadingDateRequired': '请选择本期抄表时间',
  'pages.water-fee.form.waterUsage': '用水量',
  'pages.water-fee.form.waterUsageAuto': '自动计算',
  'pages.water-fee.form.unitPrice': '单价',
  'pages.water-fee.form.unitPricePlaceholder': '请输入单价',
  'pages.water-fee.form.unitPriceRequired': '请输入单价',
  'pages.water-fee.form.baseAmount': '基础金额',
  'pages.water-fee.form.baseAmountAuto': '自动计算',
  'pages.water-fee.form.lateFee': '滞纳金',
  'pages.water-fee.form.lateFeePlaceholder': '请输入滞纳金',
  'pages.water-fee.form.discountAmount': '优惠金额',
  'pages.water-fee.form.discountAmountPlaceholder': '请输入优惠金额',
  'pages.water-fee.form.finalAmount': '最终金额',
  'pages.water-fee.form.finalAmountAuto': '自动计算',
  'pages.water-fee.form.finalAmountRequired': '最终金额将自动计算',
  'pages.water-fee.form.remarks': '备注',
  'pages.water-fee.form.remarksPlaceholder': '请输入备注信息',
  'pages.water-fee.form.remarksMaxLength': '备注长度不能超过500个字符',

  // 表单验证和错误消息
  'pages.water-fee.form.serviceNotAvailable': '该房屋没有开通水费服务，请选择其他房屋',
  'pages.water-fee.form.loadPriceConfigError': '加载水费价格配置失败',
  'pages.water-fee.form.submitSuccess': '创建成功',
  'pages.water-fee.form.updateSuccess': '更新成功',
  'pages.water-fee.form.submitError': '提交失败',

  // 货币单位
  'pages.water-fee.currency.php': '₱',

  // 分页
  'pages.water-fee.table.pagination.showTotal': '第 {start}-{end} 条/总共 {total} 条',

  // 导入相关
  'pages.water-fee.import.modalTitle': '批量导入水费账单',
  'pages.water-fee.import.confirmImport': '确认导入',
  'pages.water-fee.import.cancel': '取消',
  'pages.water-fee.import.step1': '第一步：下载导入模板',
  'pages.water-fee.import.downloadTemplate': '下载水费账单Excel模板',
  'pages.water-fee.import.step2': '第二步：选择账期并上传填写好的Excel文件',
  'pages.water-fee.import.selectPeriod': '选择账期：',
  'pages.water-fee.import.selectPeriodPlaceholder': '请选择账期',
  'pages.water-fee.import.uploadFile': '上传文件：',
  'pages.water-fee.import.uploadHint': '点击或拖拽Excel文件到此区域',
  'pages.water-fee.import.uploadFormatHint': '仅支持 .xls 和 .xlsx 格式的Excel文件，文件大小不超过10MB',
  'pages.water-fee.import.notices': '注意事项：',
  'pages.water-fee.import.notice1': '请先选择账期和Excel文件，然后点击"确认导入"按钮',
  'pages.water-fee.import.notice2': '请下载模板，按照模板格式填写数据',
  'pages.water-fee.import.notice3': '必填字段不能为空',
  'pages.water-fee.import.notice4': '日期格式请按照模板中的示例填写',
  'pages.water-fee.import.notice5': '导入前请检查数据的准确性',
  'pages.water-fee.import.notice6': '如果某一行数据异常，将不会导入该数据',
  'pages.water-fee.import.notice7': '如果数据已存在，将不会导入该数据',
  'pages.water-fee.import.notice8': '导入数据较多时可能处理较慢，请耐心等待',
  'pages.water-fee.import.successTitle': '导入请求已提交',
  'pages.water-fee.import.successMessage': '数据正在导入中，请稍后刷新页面查看导入结果！',
  'pages.water-fee.import.selectPeriodFirst': '请先选择账期！',
  'pages.water-fee.import.selectFileFirst': '请先选择要上传的Excel文件！',
  'pages.water-fee.import.invalidFile': '文件无效，请重新选择！',
  'pages.water-fee.import.importFailed': '导入失败，请检查文件格式',
  'pages.water-fee.import.downloadSuccess': '模板下载成功',
  'pages.water-fee.import.downloadFailed': '模板下载失败',
  'pages.water-fee.import.downloadFormatError': '下载的文件格式不正确',
  'pages.water-fee.import.downloadEmptyError': '下载的文件为空',
  'pages.water-fee.import.fileSizeError': '文件大小不能超过10MB!',

  // 账期查询弹窗
  'pages.water-fee.period.modalTitle': '房间查询 - {houseName} - 账期 {period}',
  'pages.water-fee.period.noData': '暂无数据',
  'pages.water-fee.period.currentMonthUsage': '本月用水量',
  'pages.water-fee.period.currentMonthAmount': '本月应缴金额',
  'pages.water-fee.period.avgUsage': '平均用水度数',
  'pages.water-fee.period.currentMonthPrice': '本月单价',
  'pages.water-fee.period.usageChange': '环比增减',
  'pages.water-fee.period.vsLastMonth': '较上月',
  'pages.water-fee.period.noComparisonData': '无可比数据',
  'pages.water-fee.period.amountChange': '金额比增减',
  'pages.water-fee.period.vsLastMonthAmount': '较上月应缴',
  'pages.water-fee.period.avgPrice': '平均单价',
  'pages.water-fee.period.pricePerTon': '每吨（含服务费）',
  'pages.water-fee.period.usageTrendTitle': '近6个月用水量趋势',
  'pages.water-fee.period.amountTrendTitle': '近6个月应缴金额趋势',
  'pages.water-fee.period.detailTableTitle': '月度详细数据',
  'pages.water-fee.period.month': '月份',
  'pages.water-fee.period.unitPrice': '单价(元/吨)',
  'pages.water-fee.period.amount': '应缴金额(元)',
  'pages.water-fee.period.lateFee': '滞纳金(元)',
  'pages.water-fee.period.discountAmount': '优惠金额(元)',
  'pages.water-fee.period.finalAmount': '最终金额(元)',
  'pages.water-fee.period.status': '状态',

  // 状态相关
  'pages.water-fee.status.unpaid': '未缴费',
  'pages.water-fee.status.paid': '已缴费',
  'pages.water-fee.status.overdue': '逾期',
  'pages.water-fee.status.partial': '部分缴费',
  'pages.water-fee.status.cancelled': '已取消',

  // 审核状态
  'pages.water-fee.approvalStatus.draft': '草稿',
  'pages.water-fee.approvalStatus.pending': '待审核',
  'pages.water-fee.approvalStatus.approved': '已通过',
  'pages.water-fee.approvalStatus.rejected': '已拒绝',
  'pages.water-fee.approvalStatus.notified': '已通知',
  'pages.water-fee.approvalStatus.overdue': '逾期',
  'pages.water-fee.approvalStatus.cancelled': '已取消',

  // 详情弹窗中的硬编码文本
  'pages.water-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.water-fee.detail.houseInfo': '房屋信息',
  'pages.water-fee.detail.ownerInfo': '业主信息',
  'pages.water-fee.detail.ownerId': '业主ID',
  'pages.water-fee.detail.meterReadingInfo': '抄表信息',
  'pages.water-fee.detail.lastReading': '上期读数(吨)',
  'pages.water-fee.detail.lastReadingDate': '上期抄表时间',
  'pages.water-fee.detail.currentReading': '本期读数(吨)',
  'pages.water-fee.detail.currentReadingDate': '本期抄表时间',
  'pages.water-fee.detail.waterUsage': '用水量',
  'pages.water-fee.detail.unitPrice': '单价(元/吨)',
  'pages.water-fee.detail.amountInfo': '金额信息',
  'pages.water-fee.detail.baseAmount': '基础金额',
  'pages.water-fee.detail.lateFee': '滞纳金',
  'pages.water-fee.detail.discountAmount': '优惠金额',
  'pages.water-fee.detail.finalAmount': '最终金额',
  'pages.water-fee.detail.paymentInfo': '缴费信息',
  'pages.water-fee.detail.paymentMethod': '支付方式',
  'pages.water-fee.detail.paymentReference': '支付凭证号',
  'pages.water-fee.detail.dueDate': '到期日期',
  'pages.water-fee.detail.paymentDate': '缴费日期',
  'pages.water-fee.detail.systemInfo': '系统信息',
  'pages.water-fee.detail.createdTime': '创建时间',
  'pages.water-fee.detail.updatedTime': '更新时间',
  'pages.water-fee.detail.remarks': '备注',
  'pages.water-fee.detail.auditRecord': '审核记录',
  'pages.water-fee.detail.loading': '加载中...',
  'pages.water-fee.detail.noAuditRecord': '暂无审核记录',

  // 表单字段硬编码文本
  'pages.water-fee.form.basicInfo': '基本信息',
  'pages.water-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.water-fee.form.meterReadingInfo': '水表读数信息',
  'pages.water-fee.form.feeInfo': '费用信息',
  'pages.water-fee.form.remarksInfo': '备注信息',

  // 表单字段标签和占位符
  'pages.water-fee.form.billNo.label': '账单编号',
  'pages.water-fee.form.billNo.placeholder': '请输入账单编号',
  'pages.water-fee.form.paymentStatus.label': '缴费状态',
  'pages.water-fee.form.paymentStatus.placeholder': '请选择缴费状态',
  'pages.water-fee.form.period.label': '账期',
  'pages.water-fee.form.period.placeholder': '如：2024-01',
  'pages.water-fee.form.period.required': '请输入账期',
  'pages.water-fee.form.startDate.label': '开始日期',
  'pages.water-fee.form.startDate.placeholder': '请选择开始日期',
  'pages.water-fee.form.startDate.required': '请选择开始日期',
  'pages.water-fee.form.endDate.label': '结束日期',
  'pages.water-fee.form.endDate.placeholder': '请选择结束日期',
  'pages.water-fee.form.endDate.required': '请选择结束日期',
  'pages.water-fee.form.building.label': '楼栋',
  'pages.water-fee.form.building.placeholder': '请选择楼栋',
  'pages.water-fee.form.building.required': '请选择楼栋',
  'pages.water-fee.form.floor.label': '楼层',
  'pages.water-fee.form.floor.placeholder': '请选择楼层',
  'pages.water-fee.form.floor.required': '请选择楼层',
  'pages.water-fee.form.house.label': '房屋',
  'pages.water-fee.form.house.placeholder': '请选择房屋',
  'pages.water-fee.form.house.required': '请选择房屋',
  'pages.water-fee.form.lastReading.label': '上期读数',
  'pages.water-fee.form.lastReading.placeholder': '请输入上期读数',
  'pages.water-fee.form.lastReadingDate.label': '上期抄表时间',
  'pages.water-fee.form.lastReadingDate.placeholder': '请选择上期抄表时间',
  'pages.water-fee.form.currentReading.label': '本期读数',
  'pages.water-fee.form.currentReading.placeholder': '请输入本期读数',
  'pages.water-fee.form.currentReading.required': '请输入本期读数',
  'pages.water-fee.form.currentReadingDate.label': '本期抄表时间',
  'pages.water-fee.form.currentReadingDate.placeholder': '请选择本期抄表时间',
  'pages.water-fee.form.currentReadingDate.required': '请选择本期抄表时间',
  'pages.water-fee.form.waterUsage.label': '用水量',
  'pages.water-fee.form.waterUsage.placeholder': '自动计算',
  'pages.water-fee.form.unitPrice.label': '单价',
  'pages.water-fee.form.unitPrice.placeholder': '请输入单价',
  'pages.water-fee.form.unitPrice.required': '请输入单价',
  'pages.water-fee.form.baseAmount.label': '基础金额',
  'pages.water-fee.form.baseAmount.placeholder': '自动计算',
  'pages.water-fee.form.lateFee.label': '滞纳金',
  'pages.water-fee.form.lateFee.placeholder': '请输入滞纳金',
  'pages.water-fee.form.discountAmount.label': '优惠金额',
  'pages.water-fee.form.discountAmount.placeholder': '请输入优惠金额',
  'pages.water-fee.form.finalAmount.label': '最终金额',
  'pages.water-fee.form.finalAmount.placeholder': '自动计算',
  'pages.water-fee.form.finalAmount.required': '最终金额将自动计算',
  'pages.water-fee.form.remarks.label': '备注',
  'pages.water-fee.form.remarks.placeholder': '请输入备注信息',
  'pages.water-fee.form.remarks.maxLength': '备注长度不能超过500个字符',

  // 导入模态框中剩余的硬编码文本
  'pages.water-fee.import.modalTitle': '批量导入水费账单',
  'pages.water-fee.import.step1.title': '第一步：下载导入模板',
  'pages.water-fee.import.step2.title': '第二步：选择账期并上传填写好的Excel文件',
  'pages.water-fee.import.selectPeriod.label': '选择账期：',

  // 账期查询模态框中的硬编码文本
  'pages.water-fee.period.modalTitle': '房间查询 - {houseName} - 账期 {period}',
  'pages.water-fee.period.currentMonthUsage': '本月用水量',
  'pages.water-fee.period.currentMonthAmount': '本月应缴金额',
  'pages.water-fee.period.avgUsage': '平均用水度数',
  'pages.water-fee.period.currentMonthPrice': '本月单价',
  'pages.water-fee.period.usageChange': '环比增减',
  'pages.water-fee.period.vsLastMonth': '较上月',
  'pages.water-fee.period.noComparisonData': '无可比数据',
  'pages.water-fee.period.amountChange': '金额比增减',
  'pages.water-fee.period.vsLastMonthAmount': '较上月应缴',
  'pages.water-fee.period.avgPrice': '平均单价',
  'pages.water-fee.period.pricePerTon': '每吨（含服务费）',
  'pages.water-fee.period.usageTrendTitle': '近6个月用水量趋势',
  'pages.water-fee.period.amountTrendTitle': '近6个月应缴金额趋势',
  'pages.water-fee.period.detailTableTitle': '月度详细数据',
  'pages.water-fee.period.month': '月份',
  'pages.water-fee.period.unitPrice': '单价(元/吨)',
  'pages.water-fee.period.amount': '应缴金额(元)',
  'pages.water-fee.period.lateFee': '滞纳金(元)',
  'pages.water-fee.period.discountAmount': '优惠金额(元)',
  'pages.water-fee.period.finalAmount': '最终金额(元)',
  'pages.water-fee.period.status': '状态',
  'pages.water-fee.period.noData': '暂无数据',

  // 单位
  'pages.water-fee.unit.ton': '吨',
  'pages.water-fee.unit.phpPerTon': '₱/吨',

  // Detail组件字段
  'pages.water-fee.detail.basicInfo': '基本信息',
  'pages.water-fee.detail.billNo': '账单编号',
  'pages.water-fee.detail.period': '账期',
  'pages.water-fee.detail.paymentStatus': '缴费状态',
  'pages.water-fee.detail.approvalStatus': '审核状态',
  'pages.water-fee.detail.startDate': '开始日期',
  'pages.water-fee.detail.endDate': '结束日期',
  'pages.water-fee.detail.houseOwnerInfo': '房屋与业主信息',
  'pages.water-fee.detail.houseInfo': '房屋信息',
  'pages.water-fee.detail.ownerInfo': '业主信息',
  'pages.water-fee.detail.meterReadingInfo': '抄表信息',
  'pages.water-fee.detail.lastReading': '上期读数',
  'pages.water-fee.detail.lastReadingDate': '上期抄表时间',
  'pages.water-fee.detail.currentReading': '本期读数',
  'pages.water-fee.detail.currentReadingDate': '本期抄表时间',
  'pages.water-fee.detail.waterUsage': '用水量',
  'pages.water-fee.detail.unitPrice': '单价',
  'pages.water-fee.detail.amountInfo': '金额信息',
  'pages.water-fee.detail.baseAmount': '基础金额',
  'pages.water-fee.detail.lateFee': '滞纳金',
  'pages.water-fee.detail.discountAmount': '优惠金额',
  'pages.water-fee.detail.finalAmount': '最终金额',
  'pages.water-fee.detail.paymentInfo': '缴费信息',
  'pages.water-fee.detail.paymentMethod': '支付方式',
  'pages.water-fee.detail.paymentReference': '支付凭证号',
  'pages.water-fee.detail.dueDate': '到期日期',
  'pages.water-fee.detail.paymentDate': '缴费日期',
  'pages.water-fee.detail.systemInfo': '系统信息',
  'pages.water-fee.detail.createdTime': '创建时间',
  'pages.water-fee.detail.updatedTime': '更新时间',
  'pages.water-fee.detail.remarks': '备注',

  // 导入文件名模板
  'pages.water-fee.import.templateFileName': '水费账单模板_{timestamp}.xlsx',
};
